import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { ArrowRight, Award, Leaf, Heart, ShieldCheck } from "lucide-react";

const About = () => {
  const { lang, t } = useI18n();
  const content = lang === "nl" ? {
    eyebrow: "Over SnapShop",
    title: "Een Nederlandse winkel die zorgvuldig kiest.",
    intro: "SnapShop is opgericht in Amsterdam met één eenvoudig idee: minder spullen, betere spullen. We zoeken Europese makers en kiezen objecten die jaren meegaan — niet seizoenen.",
    pillars: [
      { icon: Award, t: "Premium kwaliteit", d: "Elk product wordt door ons team beoordeeld voordat het de winkel haalt." },
      { icon: Leaf, t: "Duurzaam waar mogelijk", d: "FSC, natuurlijke materialen en lokale productie hebben onze voorkeur." },
      { icon: Heart, t: "Lokaal & loyaal", d: "Verzonden vanuit Nederland, ondersteund door een NL-team dat binnen 24 uur reageert." },
      { icon: ShieldCheck, t: "Veilig betalen", d: "iDEAL, Klarna, kaart, Apple/Google Pay — versleuteld via Stripe." },
    ],
    stats: [["12.000+", "tevreden klanten"], ["4.9 ★", "gemiddelde beoordeling"], ["2-3 dagen", "PostNL bezorging"], ["30 dagen", "retourtermijn"]],
    cta: "Bekijk de winkel",
  } : {
    eyebrow: "About SnapShop",
    title: "A Dutch store that picks carefully.",
    intro: "SnapShop was founded in Amsterdam with one simple idea: less stuff, better stuff. We work with European makers and choose objects that last for years — not seasons.",
    pillars: [
      { icon: Award, t: "Premium quality", d: "Every product is reviewed by our team before it reaches the shop." },
      { icon: Leaf, t: "Sustainable where possible", d: "FSC, natural materials and local production whenever we can." },
      { icon: Heart, t: "Local & loyal", d: "Shipped from the Netherlands, supported by an NL team replying within 24 hours." },
      { icon: ShieldCheck, t: "Secure payments", d: "iDEAL, Klarna, card, Apple/Google Pay — encrypted via Stripe." },
    ],
    stats: [["12,000+", "happy customers"], ["4.9 ★", "average rating"], ["2-3 days", "PostNL delivery"], ["30 days", "returns window"]],
    cta: "Visit the store",
  };

  return (
    <div data-testid="about-page">
      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-12 gap-12 items-end">
        <div className="md:col-span-6">
          <div className="font-label text-terracotta mb-5">{content.eyebrow}</div>
          <h1 className="font-display text-5xl md:text-7xl tracking-tighter font-light leading-[0.95]">{content.title}</h1>
          <p className="mt-8 text-lg text-ink-muted leading-relaxed max-w-lg">{content.intro}</p>
          <Link to="/shop" className="btn-primary mt-8 text-sm">{content.cta} <ArrowRight className="w-4 h-4" /></Link>
        </div>
        <div className="md:col-span-6">
          <div className="editorial-image">
            <img src="https://images.unsplash.com/photo-1567016376408-0226e4d0c1ea?w=1200&auto=format&fit=crop" alt="" className="w-full h-[60vh] object-cover" />
          </div>
        </div>
      </section>

      <section className="bg-secondary-warm py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {content.pillars.map(({ icon: Icon, t: title, d }, i) => (
              <div key={i} className="bg-white border border-black/5 p-6 md:p-8">
                <Icon className="w-6 h-6 text-terracotta mb-4" />
                <div className="font-display text-xl leading-tight">{title}</div>
                <p className="text-sm text-ink-muted mt-2 leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 grid grid-cols-2 md:grid-cols-4 gap-8 border-y border-black/10 my-6">
        {content.stats.map(([n, l], i) => (
          <div key={i}>
            <div className="font-display text-5xl md:text-6xl tracking-tighter font-light">{n}</div>
            <div className="font-label text-ink-muted mt-2">{l}</div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default About;
